import {
  IconCircleCheck,
  IconCircleX,
  IconExclamationCircle,
} from "@tabler/icons-react";
import type { FC } from "react";

export interface FeedbackCellProps {
  value: string;
  commentary?: string;
  correctness?: { isCorrect: boolean; isClose: boolean };
}

export const FeedbackCell: FC<FeedbackCellProps> = ({
  value,
  commentary,
  correctness,
}) => (
  <div className="space-y-1">
    <div className="flex items-center gap-2 font-medium text-foreground">
      {value}
      {correctness !== undefined && correctness.isCorrect ? (
        <IconCircleCheck className="size-4 shrink-0 text-success" />
      ) : null}
      {correctness !== undefined && correctness.isClose ? (
        <IconExclamationCircle className="size-4 shrink-0 text-yellow-600" />
      ) : null}
      {correctness !== undefined &&
      !correctness.isCorrect &&
      !correctness.isClose ? (
        <IconCircleX className="size-4 shrink-0 text-destructive" />
      ) : null}
    </div>
    {commentary && <div className="text-xs text-gray-600">{commentary}</div>}
  </div>
);
